export const INFLUENCER_TYPE = "influencer";
export const PRODUCT_TYPE = "product";

export const LOOK_TALL = "tall";
export const LOOK_PRODUCT = "product";

// Desktop
const TALL_CARD_WIDTH = 208;
const WIDE_CARD_WIDTH = 308;
const PRODUCT_CARD_WIDTH = 264;
const TALL_CARD_HEIGHT = 342;
const PRODUCT_CARD_HEIGHT = 352;
const WIDE_CARD_HEIGHT = 208;
const TALL_IMAGE_HEIGHT = 280;
const WIDE_IMAGE_HEIGHT = 154;
const TALL_IMAGE_WIDTH = 208;
const WIDE_IMAGE_WIDTH = 308;

// Mobile
const M_TALL_CARD_WIDTH = 162;
const M_WIDE_CARD_WIDTH = 242;
const M_PRODUCT_CARD_WIDTH = 206;
const M_TALL_CARD_HEIGHT = 282;
const M_PRODUCT_CARD_HEIGHT = 310;
const M_WIDE_CARD_HEIGHT = 182;
const M_TALL_IMAGE_HEIGHT = 216;
const M_WIDE_IMAGE_HEIGHT = 126;
const M_TALL_IMAGE_WIDTH = 162;
const M_WIDE_IMAGE_WIDTH = 242;

export function imageHeightFor({ isMobile, look = LOOK_TALL }) {
  if (look === LOOK_TALL) {
    return isMobile ? M_TALL_IMAGE_HEIGHT : TALL_IMAGE_HEIGHT;
  }

  return isMobile ? M_WIDE_IMAGE_HEIGHT : WIDE_IMAGE_HEIGHT;
}

export function imageWidthFor({ isMobile, look = LOOK_TALL }) {
  if (look === LOOK_TALL) {
    return isMobile ? M_TALL_IMAGE_WIDTH : TALL_IMAGE_WIDTH;
  }

  return isMobile ? M_WIDE_IMAGE_WIDTH : WIDE_IMAGE_WIDTH;
}

export function cardHeightFor({ isMobile, look = LOOK_TALL }) {
  if (look === LOOK_TALL) {
    return isMobile ? M_TALL_CARD_HEIGHT : TALL_CARD_HEIGHT;
  }

  if (look === LOOK_PRODUCT) {
    return isMobile ? M_PRODUCT_CARD_HEIGHT : PRODUCT_CARD_HEIGHT;
  }

  return isMobile ? M_WIDE_CARD_HEIGHT : WIDE_CARD_HEIGHT;
}

export function cardWidthFor({ isMobile, look = LOOK_TALL }) {
  if (look === LOOK_TALL) {
    return isMobile ? M_TALL_CARD_WIDTH : TALL_CARD_WIDTH;
  }

  if (look === LOOK_PRODUCT) {
    return isMobile ? M_PRODUCT_CARD_WIDTH : PRODUCT_CARD_WIDTH;
  }

  return isMobile ? M_WIDE_CARD_WIDTH : WIDE_CARD_WIDTH;
}

export function isTall(look) {
  return look === LOOK_TALL;
}

export function isProduct(look) {
  return look === LOOK_PRODUCT;
}
